import { AlertTriangle, CheckCircle2, CircleDashed } from 'lucide-react';
import type { SectionLayoutState } from './formSchemaTypes';

export function SectionLayoutStatusBadge({
  state,
}: {
  state: SectionLayoutState;
}) {
  if (state.kind === 'valid') {
    return (
      <span
        className='inline-flex items-center text-green-700'
        title='Custom layout'
      >
        <CheckCircle2 className='h-3.5 w-3.5' aria-hidden />
      </span>
    );
  }
  if (state.kind === 'invalid') {
    return (
      <span
        className='inline-flex items-center text-destructive'
        title={state.reason}
      >
        <AlertTriangle className='h-3.5 w-3.5' aria-hidden />
      </span>
    );
  }
  return (
    <span
      className='inline-flex items-center text-muted-foreground'
      title='No custom layout'
    >
      <CircleDashed className='h-3.5 w-3.5' aria-hidden />
    </span>
  );
}
